// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__oNE5r","img":"banner_img__14A5H","content":"banner_content__pA7ls"};